// :: Moment
import moment from 'moment/min/moment-with-locales';
import Moment from 'react-moment';
import 'moment/locale/cs';

Moment.globalMoment = moment;
Moment.globalLocale = 'cs';
Moment.globalFormat = 'D. MMMM YYYY';
Moment.globalElement = 'span';
